import { getCookie } from '@ssc-fe-common/utils';

export const getCurrentPortal = () => {
  const [rest] = window.location.host.split('.shopee.');
  // eslint-disable-next-line no-unused-vars
  if (rest.startsWith('wms')) {
    return 'WMS';
  }

  const hostnameIdentity = window.location.hostname.split('.').shift();
  // 优先特判 window.APP_CONTEXT.region，用于本地开发的时候注入 region 参数进行开发
  // https://logistics.test.myagencyservice.com.br/
  if (hostnameIdentity === 'logistics') return 'AGENCY';
  // https://wms.ssc.test.shopee.co.id
  if (hostnameIdentity?.startsWith('wms')) return 'WMS';
  // https://sp.spx.test.shopee.tw/
  if (hostnameIdentity === 'sp') return 'SP';
  // https://spx.dev.shopee.co.id/#/index
  if (hostnameIdentity === 'spx') return 'FMS';
  if (hostnameIdentity === 'wms') return 'WMS';
  return 'FMS';
};

export const isSP = () => {
  return getCurrentPortal() === 'SP';
};

export const isWMS = () => {
  return getCurrentPortal() === 'WMS';
};

export const isSPX = () => {
  return getCurrentPortal() === 'FMS';
};

export const isAGENCY = () => {
  return getCurrentPortal() === 'AGENCY';
};

export const isAgencyPortal = isAGENCY();
export const isWmsPortal = isWMS();

export const getPortalConfig = () => {
  let portalApiPrefix = '';
  let fromHost = '';
  let curEnv = ''; // test uat staging live

  if (isWmsPortal) {
    const [rest, cid] = window.location.host.split('.shopee.');
    const sscIndex = rest.indexOf('.ssc.');

    if (sscIndex > -1) {
      const hostPrefix = rest.slice(0, sscIndex);
      const sscDomain = rest.slice(sscIndex + 1);
      const [, env = 'live'] = sscDomain.split('.');

      portalApiPrefix = `https://spx-cross.${sscDomain}.shopee.${cid}`;
      curEnv = env === 'shopee' ? 'live' : env;
      fromHost = `${hostPrefix}.${sscDomain}.shopee.${cid}`;
    }
  }
  return { portalApiPrefix, fromHost, curEnv };
};

// 为了兼容 BFF 的 URL 映射
function bffUrlMappingInterceptor(request: any) {
  const { portalApiPrefix } = getPortalConfig();
  const mapping = {
    [portalApiPrefix + '/api/bff/apollo/get_config']:
      '/api/bff/apollo/cross/get_config',
    [portalApiPrefix + '/api/bff/apollo/get_config/by_cid']:
      '/api/bff/apollo/cross/get_config/by_cid',
  };
  if (mapping[request.url]) {
    request.url = portalApiPrefix + mapping[request.url];
  }
  return request;
}

let isInited = false;

export const initRequest = (requestInstance: any) => {
  if (isWmsPortal && !isInited) {
    requestInstance.axiosInstance.interceptors.request.use(
      bffUrlMappingInterceptor
    );
    isInited = true;
  }
};

export const getInjectedHeaders = () => {
  const { fromHost } = getPortalConfig();

  const pfbCookie = getCookie('_SPC_PFB');

  const injectedHeaders: Record<string, string> = {};
  if (fromHost) {
    injectedHeaders['from-host'] = fromHost;
  }
  if (pfbCookie) {
    injectedHeaders['shopee-baggage'] = 'PFB=' + pfbCookie;
  }
  return injectedHeaders;
};
